// Generated by CoffeeScript 2.7.0
var Graph;

import {
  newAlertify
} from 'trunks/vue/admin/components/alert.js';

import Ajax from 'libs/ajax.js';

import BaseModel from '../base_model.js';

import Fieldable from '../concerns/fieldable.js';

import Vertex from './vertex.js';

import Edge from './edge.js';

export default Graph = (function() {
  class Graph extends BaseModel {
    static hasInstance(something) {
      return something instanceof this;
    }

    constructor(attrs) {
      super(attrs);
      this.metadata = _.extend({}, {
        position: {
          x: 0,
          y: 0
        }
      }, attrs.metadata);
      this.vertices = _.map(attrs.vertices || [], (vertex) => {
        return Vertex.new(vertex, this);
      });
      this.settings = _.extend({}, {
        duration_threshold: {
          value: '',
          enable_manual: false,
          enable_delay: false
        },
        visibility: 'public'
      }, attrs.settings);
      this.flow = attrs.flow;
      if (attrs.initial_vertex) {
        this.initial_vertex = Vertex.new(attrs.initial_vertex, this);
      }
      if (attrs.final_vertex) {
        this.final_vertex = Vertex.new(attrs.final_vertex, this);
      }
      this.edges = _.map(attrs.edges || [], (edge) => {
        edge.from = _.findWhere(this.vertices, _.pick(edge.from, 'id'));
        edge.to = _.findWhere(this.vertices, _.pick(edge.to, 'id'));
        return Edge.new(edge);
      });
      this._makeFields(attrs.fields);
    }

    addChild(child) {
      if (!(child instanceof this.constructor)) {
        child = new this.constructor(child);
      }
      this.children.push(child);
      child.parent = this;
      return child;
    }

    getVertexLikeVertices() {
      return this.vertices.concat([this.initial_vertex, this.final_vertex]).concat(this.children);
    }

    insertVertex(vertex) {
      var exist_vertex;
      exist_vertex = _.findWhere(this.vertices, {
        id: vertex.id
      });
      if (exist_vertex) {
        return exist_vertex;
      } else {
        vertex = Vertex.new(vertex, this);
        if (vertex.isInitial) {
          this.initial_vertex = vertex;
        } else if (vertex.isFinal) {
          this.final_vertex = vertex;
        } else {
          this.vertices.push(vertex);
        }
        return vertex;
      }
    }

    insertEdge(edge) {
      var exist_edge;
      exist_edge = _.findWhere(this.edges, {
        id: edge.id
      });
      if (exist_edge) {
        return exist_edge;
      } else {
        edge = Edge.new(edge, this);
        this.edges.push(edge);
        return edge;
      }
    }

    updatePosition(position) {
      return _.extend(this.metadata.position, position);
    }

    has(attr) {
      // attr must be instanceof Vertex or Edge
      if (attr instanceof Vertex) {
        return _.contains(this.vertices, attr);
      } else {
        return _.contains(this.edges, attr);
      }
    }

    deleteVertex(vertex) {
      // 开始节点和终止节点不能删除
      if (vertex.isFinal || vertex.isInitial) {
        return;
      }
      // 删除所有的相关的edge
      this.edges = _.reject(this.edges, function(edge) {
        return (edge.from === vertex) || (edge.to === vertex);
      });
      // 删除vertex
      return this.vertices = _.rejectFirst(this.vertices, function(_vertex) {
        return _vertex === vertex;
      });
    }

    deleteEdge(edge) {
      return this.edges = _.rejectFirst(this.edges, function(_edge) {
        return _edge === edge;
      });
    }

    deleteChildrenGraph(graph) {
      this.children = _.without(this.children, graph);
      // 删除子流程时，删除上一级流程里面该子流程相关的边
      return this.edges = _.reject(this.edges, function(edge) {
        return (edge.from === graph.final_vertex) || (edge.to === graph.initial_vertex);
      });
    }

    getEdgesOfVertices(vertices) {
      return _.filter(this.edges, function(edge) {
        var from, to;
        from = edge.from.isFinal ? edge.from.graph : edge.from;
        to = edge.to.isInitial ? edge.to.graph : edge.to;
        return _.contains(vertices, from) && _.contains(vertices, to);
      });
    }

    getEdgeBetweenTwoVertices(from, to) {
      return _.find(this.edges, function(edge) {
        return (edge.from === from) && (edge.to === to);
      });
    }

    update() {
      if (!(this.isPersisted() && this.flow)) {
        return false;
      }
      this.errors.clear();
      return Ajax.patch(`/admin${this.flow.gid.toPath()}/graphs/${this.id}`, {
        data: {
          graph: this.toJSON()
        },
        contentType: 'application/json; charset=utf-8',
        responseType: 'json',
        success: (data) => {
          return this._makeFields(data.fields);
        },
        error: (xhr, status, error) => {
          var error_message;
          this.errors.merge(error);
          error_message = this.errors.fullMessages().join('; ');
          return newAlertify(error_message || '保存失败', {
            type: 'error'
          });
        }
      });
    }

    createEdge(edge) {
      return Ajax.post(`/admin${this.gid.toPath()}/edges`, {
        data: {
          edge: edge.toJSON()
        },
        contentType: 'application/json; charset=utf-8',
        responseType: 'json',
        success: (data, status, xhr) => {
          var new_edge;
          new_edge = Edge.new(data, this);
          new_edge.from = edge.from;
          new_edge.to = edge.to;
          return this.edges.push(new_edge);
        }
      });
    }

    createVertex(vertex) {
      return Ajax.post(`/admin${this.gid.toPath()}/vertices`, {
        data: {
          vertex: vertex.toJSON()
        },
        contentType: 'application/json; charset=utf-8',
        responseType: 'json',
        success: (data, status, xhr) => {
          return this.vertices.push(Vertex.new(data, this));
        },
        error: (xhr, status, error) => {
          var error_message;
          vertex = Vertex.new({}, this);
          vertex.errors.merge(error);
          error_message = vertex.errors.fullMessages().join('; ');
          return newAlertify(error_message || '保存失败', {
            type: 'error'
          });
        }
      });
    }

    createChildGraph(graph) {
      return Ajax.post(`/admin${this.flow.gid.toPath()}/graphs`, {
        data: {
          graph: graph.toJSON()
        },
        contentType: 'application/json; charset=utf-8',
        responseType: 'json',
        success: (data, status, xhr) => {
          var new_graph;
          new_graph = new this.constructor(data);
          _.extend(new_graph, {
            parent_id: this.id,
            parent: this,
            flow: this.flow,
            final_vertex_id: data.final_vertex.id,
            initial_vertex_id: data.initial_vertex.id
          });
          return this.children.push(new_graph);
        }
      });
    }

    generateChildGraph(attrs) {
      var graph;
      graph = new this.constructor(_.extend({
        name: '子流程',
        parent_id: this.id
      }, attrs));
      return graph;
    }

    enableDelete() {
      this.errors.clear();
      if (!(this.isPersisted() && this.flow)) {
        this.errors.add('graph', '未保存的子流程删除无效');
      }
      if (!this.errors.isBlank()) {
        return false;
      }
      return true;
    }

    delete() {
      if (!this.enableDelete()) {
        return;
      }
      return Ajax.delete(`/admin${this.flow.gid.toPath()}/graphs/${this.id}`, {
        success: () => {
          return this.deleteSucceeded();
        }
      });
    }

    deleteSucceeded() {
      var ref;
      return (ref = this.parent) != null ? ref.deleteChildrenGraph(this) : void 0;
    }

    copy(metadata) {
      return Ajax.post(`/admin${this.flow.gid.toPath()}/graphs/${this.id}/copy`, {
        contentType: 'application/json; charset=utf-8',
        responseType: 'json',
        data: metadata,
        success: (data) => {
          var edges, graphs, vertices;
          ({graphs, vertices, edges} = data);
          return this.parent.addChild(this.flow.generateGraph(graphs, vertices, edges));
        }
      });
    }

    isRootGraph() {
      return !this.getAncestors().length;
    }

    isValidGraph() {
      this.validateGraph();
      return !Boolean(this._errors.length);
    }

    validateGraph() {
      _.map(this.getVertexLikeVertices(), function(vertex) {
        return vertex._status = 'normal';
      });
      _.map(this.edges, function(edge) {
        return edge._status = 'normal';
      });
      this._status = 'normal';
      this._errors = [];
      this.validateNormalVertices();
      this.validateCircle();
      return this.validateChildren();
    }

    validateChildren() {
      var child, i, len, ref, results;
      ref = this.children;
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        child = ref[i];
        if (!child.isValidGraph()) {
          this._status = 'danger';
          this._errors.push({
            message: '子流程不合法',
            type: 'childInvalid',
            data: child
          });
          break;
        } else {
          results.push(void 0);
        }
      }
      return results;
    }

    validateNormalVertices() {
      if (!(this.vertices.length || this.children.length)) {
        this._status = 'danger';
        return this._errors.push({
          message: '没有任何的中间节点',
          type: 'incompleted',
          data: null
        });
      }
    }

    validateCircle() {
      var circle_info;
      circle_info = this.getCircleCheckInfo();
      if (circle_info) {
        return this._errors.push(circle_info);
      }
    }

    getCircleCheckInfo() {
      var DFS, stack, vertices;
      vertices = this.getVertexLikeVertices();
      stack = [];
      DFS = (vertex) => {
        var _vertex, circle, i, index, len, targets;
        // 如果是子图的开始节点或终止节点，则应使用子图来替代节点
        if ((vertex.isInitial || vertex.isFinal) && (vertex.graph !== this)) {
          vertex = vertex.graph;
        }
        vertices = _.without(vertices, vertex);
        // 已经成环
        if ((index = _.indexOf(stack, vertex)) !== -1) {
          return {
            message: '存在环路',
            data: stack.slice(index),
            type: 'circled'
          };
        } else {
          targets = vertex.getTargets();
          if (targets.length) {
            stack.push(vertex);
            for (i = 0, len = targets.length; i < len; i++) {
              _vertex = targets[i];
              circle = DFS(_vertex);
              if (circle) {
                return circle;
              }
            }
            stack.pop();
          }
        }
        if (vertices.length && !stack.length) {
          return {
            message: '有孤立的流程',
            type: 'isolated',
            data: vertices
          };
        } else {
          return null;
        }
      };
      return DFS(this.initial_vertex);
    }

    // 获取所有的下一跳
    getTargets() {
      var edges;
      if (!this.parent) {
        return [];
      }
      edges = this.parent.edges || [];
      return this.final_vertex.getTargets(edges);
    }

    getOwnFields() {
      return this.fields;
    }

    getChildrenGraphs() {
      return _.reduce(this.children, function(result, graph) {
        return result.concat([graph]).concat(graph.getChildrenGraphs());
      }, []);
    }

    // [root, someAncestors, parent]
    getAncestors() {
      var graph, result;
      result = [];
      graph = this;
      while (graph.parent) {
        result.unshift(graph.parent);
        graph = graph.parent;
      }
      return result;
    }

    getRootGraph() {
      var graph;
      graph = this;
      while (graph.parent) {
        graph = graph.parent;
      }
      return graph;
    }

    getAllVertices() {
      return this.vertices.concat([this.initial_vertex, this.final_vertex]);
    }

    findVertexById(vertex_id) {
      var child, i, len, ref, v, vertex;
      vertex = _.findWhere(this.vertices, {
        id: vertex_id
      });
      if (vertex) {
        return vertex;
      }
      ref = this.children;
      for (i = 0, len = ref.length; i < len; i++) {
        child = ref[i];
        if (v = child.findVertexById(vertex_id)) {
          return v;
        }
      }
    }

    findGraphById(child_id) {
      var child, g, i, len, ref;
      if (this.id === child_id) {
        return this;
      }
      ref = this.children;
      for (i = 0, len = ref.length; i < len; i++) {
        child = ref[i];
        if (g = child.findGraphById(vertex_id)) {
          return g;
        }
      }
    }

    toJSON() {
      var graph;
      graph = super.toJSON();
      graph.fields_attributes = _.map(this.fields, function(field, index) {
        field.position = index;
        return field.toJSON();
      });
      return _.omit(graph, 'flow', 'parent', 'children', 'fields', 'edges', 'vertices', 'initial_vertex', 'final_vertex', '_status');
    }

  };

  Graph.setAttributes([
    {
      name: '',
      metadata: {
        position: {
          x: 0,
          y: 0
        }
      }
    },
    '_status',
    'initial_vertex',
    'final_vertex',
    'initial_vertex_id',
    'final_vertex_id',
    'flow_id',
    'flow',
    {
      vertices: [],
      edges: [],
      fields: [],
      settings: {}
    },
    'parent',
    'parent_id',
    {
      children: []
    }
  ]);

  return Graph;

}).call(this);

Graph.assemble(Fieldable);
